import { createFileRoute, redirect } from '@tanstack/react-router'

import { HistoricalMatchPage } from '~/features/football-history/history-pages'
import { canonicalMatchHref } from '~/features/football-history/links'
import { historicalMatchQueryOptions } from '~/features/football-history/query-options'
import {
  historicalMatchSearchSchema,
  parseHistoricalMatchSearch,
  validateHistoricalMatchRouteParams,
} from '~/features/football-history/search-schema'
import { parseMatchDetailSearch } from '~/features/football-match-detail/back-navigation'
import {
  footballCoreHref,
  footballCoreLocale,
} from '~/lib/navigation/football-core'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/$locale/_public/history/matches/$historicalMatchId')({
  validateSearch: (search: unknown) => parsePublicFootballRouteInput(historicalMatchSearchSchema, search),
  beforeLoad: ({ params, search }) => {
    validateHistoricalMatchRouteParams(params)
    parseHistoricalMatchSearch(search, footballCoreLocale(params.locale))
  },
  head: ({ params }) => seo({
    title: '历史比赛详情 | BallPeek',
    description: '带有有限来源与字段覆盖说明的描述性历史足球记录。',
    pathname: `/history/matches/${encodeURIComponent(params.historicalMatchId)}`,
    locale: params.locale,
  }),
  loader: async ({ context, params, location }) => {
    const result = await context.queryClient
      .fetchQuery(historicalMatchQueryOptions(params.historicalMatchId))
      .catch(() => null)
    if (result?.kind === 'canonical') {
      const locale = footballCoreLocale(params.locale)
      const search = parseMatchDetailSearch(location.search, locale)
      throw redirect({
        href: canonicalMatchHref(locale, result.matchId, search.back ?? footballCoreHref(locale, '/matches')),
      })
    }
  },
  component: LocalizedHistoricalMatchRoute,
})

function LocalizedHistoricalMatchRoute() {
  const params = Route.useParams()
  return (
    <HistoricalMatchPage
      historicalMatchId={params.historicalMatchId}
      back={Route.useSearch().back}
    />
  )
}
